import { z } from 'zod'

export { trainerAffiliateListResponseSchema } from './trainer-affiliate-read'
export type { TrainerAffiliateListResponse } from './trainer-affiliate-read'
/**
 * Affiliate write handlers retain their existing body validation and exact
 * errors. These schemas keep legacy snake/camel filter fields passthrough so
 * clients and tests share the accepted transport shape without moving policy.
 */
export const trainerAffiliateListRequestSchema = z.object({
  users_id: z.unknown(),
  search: z.unknown().optional(),
  ownerUserId: z.unknown().optional(),
  owner_user_id: z.unknown().optional(),
  dateFrom: z.unknown().optional(),
  date_from: z.unknown().optional(),
  dateTo: z.unknown().optional(),
  date_to: z.unknown().optional(),
  identityStatus: z.unknown().optional(),
  identity_status: z.unknown().optional(),
  payoutStatus: z.unknown().optional(),
  payout_status: z.unknown().optional(),
}).passthrough()


export type TrainerAffiliateListRequest = z.infer<typeof trainerAffiliateListRequestSchema>
